__turbopack_context__.v({
  "iconButton": "C7ViTa_iconButton",
  "selected": "C7ViTa_selected",
});
